const ReferralCodeInActiveIcon = () => {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g opacity='0.5'>
        <path
          opacity='0.4'
          d='M17.53 8.5786C17.46 8.5686 17.39 8.5686 17.32 8.5786C15.77 8.5286 14.54 7.25859 14.54 5.69859C14.54 4.10859 15.83 2.80859 17.43 2.80859C19.02 2.80859 20.32 4.09859 20.32 5.69859C20.31 7.25859 19.08 8.5286 17.53 8.5786Z'
          fill='#292D32'
        />
        <path
          opacity='0.4'
          d='M20.79 15.509C19.67 16.259 18.1 16.539 16.65 16.349C17.03 15.529 17.23 14.619 17.24 13.659C17.24 12.659 17.02 11.709 16.6 10.879C18.08 10.679 19.65 10.959 20.78 11.709C22.36 12.749 22.36 14.459 20.79 15.509Z'
          fill='#292D32'
        />
        <path
          opacity='0.4'
          d='M6.44002 8.5786C6.51002 8.5686 6.58002 8.5686 6.65002 8.5786C8.20002 8.5286 9.43002 7.25859 9.43002 5.69859C9.43002 4.10859 8.14002 2.80859 6.54002 2.80859C4.95002 2.80859 3.65002 4.09859 3.65002 5.69859C3.66002 7.25859 4.89002 8.5286 6.44002 8.5786Z'
          fill='#292D32'
        />
        <path
          opacity='0.4'
          d='M6.54999 13.6592C6.54999 14.6292 6.75999 15.5492 7.13999 16.3792C5.72999 16.5292 4.26 16.2292 3.18 15.5192C1.6 14.4692 1.6 12.7592 3.18 11.7092C4.25 10.9892 5.76 10.6992 7.18 10.8592C6.77 11.6992 6.54999 12.6492 6.54999 13.6592Z'
          fill='#292D32'
        />
        <path
          d='M12.12 16.6786C12.04 16.6686 11.95 16.6686 11.86 16.6786C10.02 16.6186 8.54999 15.1086 8.54999 13.2486C8.54999 11.3486 10.08 9.80859 11.99 9.80859C13.89 9.80859 15.43 11.3486 15.43 13.2486C15.43 15.1086 13.97 16.6186 12.12 16.6786Z'
          fill='#292D32'
        />
        <path
          d='M8.86999 18.7492C7.35999 19.7592 7.35999 21.4192 8.86999 22.4192C10.59 23.5692 13.41 23.5692 15.13 22.4192C16.64 21.4092 16.64 19.7492 15.13 18.7492C13.42 17.5992 10.6 17.5992 8.86999 18.7492Z'
          fill='#292D32'
        />
      </g>
    </svg>
  );
};
export { ReferralCodeInActiveIcon };
